module.exports = __webpack_public_path__ + "media/images/new_home/cross-b0174d8ce9110240ad36bbf5547ab8ed.png";